import { useState, useEffect, useMemo } from "react";

const ImageSlider = ({ imageList = [], rounded = false }) => {
  // Ensure imageList is always an array, even if null is passed
  const safeImageList = useMemo(() => imageList ?? [], [imageList]);
  const [currentImage, setCurrentImage] = useState(0);
  const [nextImage, setNextImage] = useState(null);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (!safeImageList || safeImageList.length <= 1) return;

    const interval = setInterval(() => {
      const nextIndex = (currentImage + 1) % safeImageList.length;
      setNextImage(nextIndex);
      setIsFading(true);

      // Wait for fade transition
      setTimeout(() => {
        setCurrentImage(nextIndex);
        setIsFading(false);
      }, 400); // match CSS duration
    }, 5000); // 5 seconds per slide

    return () => clearInterval(interval);
  }, [currentImage, safeImageList]);

  const currentSrc =
    safeImageList.length > 0
      ? safeImageList[currentImage]
      : "https://placehold.co/890x1024?text=No+Image";

  const nextSrc = nextImage !== null ? safeImageList[nextImage] : null;

  return (
    <div className="w-full h-full flex items-center justify-center overflow-hidden relative">
      {/* Current Image */}
      <img
        src={currentSrc}
        alt="slider current"
        className={`absolute w-full h-full object-cover top-0 left-0 transition-opacity duration-1000 ease-in-out ${
          isFading ? "opacity-0" : "opacity-100"
        } ${rounded ? "rounded-lg" : ""}`}
      />

      {/* Next Image */}
      {nextSrc && (
        <img
          src={nextSrc}
          alt="slider next"
          className={`absolute w-full h-full object-cover top-0 left-0 transition-opacity duration-1000 ease-in-out ${
            isFading ? "opacity-100" : "opacity-0"
          } ${rounded ? "rounded-lg" : ""}`}
        />
      )}
    </div>
  );
};

export default ImageSlider;
